export function resolveDefaultCampaignAudienceId(audiences) {
  const eligible = (audiences || []).filter(audience => audience && !audience.isDeleted)
  const everyoneAudience = eligible.find(
    audience => audience.name?.trim().toLowerCase() === 'everyone'
  )

  return everyoneAudience?.id
}

const PROTECTED_DEFAULT_AUDIENCE_NAMES = [
  'everyone',
  'everyone local',
  'ota all',
  'ota local'
]

export function isProtectedDefaultAudience(audienceOrName) {
  if (audienceOrName && typeof audienceOrName === 'object') {
    if (audienceOrName.isProtected != null) {
      return audienceOrName.isProtected
    }

    return isProtectedDefaultAudience(audienceOrName.name)
  }

  const normalized = audienceOrName?.trim().toLowerCase()
  return PROTECTED_DEFAULT_AUDIENCE_NAMES.includes(normalized)
}

export function hasMeaningfulCutoffDate(deliveryFinishDate) {
  if (!deliveryFinishDate) {
    return false
  }

  const parsed = new Date(deliveryFinishDate)
  return !Number.isNaN(parsed.getTime()) && parsed.getFullYear() > 1
}
